import axios from "axios";
import { apiEndpoint } from "../../../routes/api_endpoints";
import { API_KEY } from "../../../utilities/apiKey";

const reserveTicketsBody = ({
  MovieProviderID = "6166ebc5180b4",
  MovieID = "57785",
  ScreenID = "57785",
  ShowID = "57785",
  ShowDate = "12:00 PM",
  Seats = [
    {
      SeatPrice: "600",
      SeatNumber: "E4",
      TicketCode: "2156",
      SeatDescription: "",
    },
  ],
  MobileNumber = "254700928129",
}) => ({
  RequestID: "RESERVETICKETS",
  SessionID: "HBhGpLw0efgwbDqILlYSCC9WT5hoo=4oCh",
  Country: "KENYA",
  City: "NAIROBI",
  UserID: "Pesapal",
  Key: "2344",
  MobileNumber,
  TrxReference: "123487",
  IMEI: "231766434532535",
  MovieTickets: {
    GetPrice: "Y",
    MovieDetails: {
      MovieID: MovieID,
      ScreenID: ScreenID,
      MovieProviderID: MovieProviderID,
      Quantity: Seats.length,
      Seats: Seats,
    },
    ShowDate: ShowDate,
    ShowID: ShowID,
  },
});

const reserveSeats = ({
  MovieProviderID = "6166ebc5180b4",
  MovieID = "57785",
  ScreenID = "57785",
  ShowID = "57785",
  ShowDate = "12:00 PM",
  Seats = [
    {
      SeatPrice: "600",
      SeatNumber: "E4",
      TicketCode: "2156",
      SeatDescription: "",
    },
  ],
  MobileNumber = "254700928129",
}) =>
  new Promise((resolve, reject) => {
    const body = reserveTicketsBody({
      MovieProviderID,
      MovieID,
      ScreenID,
      ShowID,
      ShowDate,
      Seats,
      MobileNumber,
    });

    console.log("body", body);
    axios
      .post(apiEndpoint, body, {
        headers: {
          "X-API-KEY": API_KEY,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(error));
  });

export default reserveSeats;
